export const ADMIN_GET_QUESTIONS_REQUEST = 'ADMIN_GET_QUESTIONS_REQUEST';
export const ADMIN_GET_QUESTIONS_SUCCESS = 'ADMIN_GET_QUESTIONS_SUCCESS';
export const ADMIN_GET_QUESTIONS_ERROR = 'ADMIN_GET_QUESTIONS_ERROR';

export const ADMIN_GET_QUESTION_REQUEST = 'ADMIN_GET_QUESTION_REQUEST';
export const ADMIN_GET_QUESTION_SUCCESS = 'ADMIN_GET_QUESTION_SUCCESS';
export const ADMIN_GET_QUESTION_ERROR = 'ADMIN_GET_QUESTION_ERROR';

export const ADMIN_ADD_QUESTION_REQUEST = 'ADMIN_ADD_QUESTION_REQUEST';
export const ADMIN_ADD_QUESTION_SUCCESS = 'ADMIN_ADD_QUESTION_SUCCESS';
export const ADMIN_ADD_QUESTION_ERROR = 'ADMIN_ADD_QUESTION_ERROR';

export const ADMIN_UPDATE_QUESTION_REQUEST = 'ADMIN_UPDATE_QUESTION_REQUEST';
export const ADMIN_UPDATE_QUESTION_SUCCESS = 'ADMIN_UPDATE_QUESTION_SUCCESS';
export const ADMIN_UPDATE_QUESTION_ERROR = 'ADMIN_UPDATE_QUESTION_ERROR';

export const ADMIN_DELETE_QUESTION_REQUEST = 'ADMIN_DELETE_QUESTION_REQUEST';
export const ADMIN_DELETE_QUESTION_SUCCESS = 'ADMIN_DELETE_QUESTION_SUCCESS';
export const ADMIN_DELETE_QUESTION_ERROR = 'ADMIN_DELETE_QUESTION_ERROR';

export const ADMIN_GET_TAGS_REQUEST = 'ADMIN_GET_TAGS_REQUEST';
export const ADMIN_GET_TAGS_SUCCESS = 'ADMIN_GET_TAGS_SUCCESS';
export const ADMIN_GET_TAGS_ERROR = 'ADMIN_GET_TAGS_ERROR';

export const ADMIN_GET_TAG_REQUEST = 'ADMIN_GET_TAG_REQUEST';
export const ADMIN_GET_TAG_SUCCESS = 'ADMIN_GET_TAG_SUCCESS';
export const ADMIN_GET_TAG_ERROR = 'ADMIN_GET_TAG_ERROR';

export const ADMIN_ADD_TAG_REQUEST = 'ADMIN_ADD_TAG_REQUEST';
export const ADMIN_ADD_TAG_SUCCESS = 'ADMIN_ADD_TAG_SUCCESS';
export const ADMIN_ADD_TAG_ERROR = 'ADMIN_ADD_TAG_ERROR';

export const ADMIN_UPDATE_TAG_REQUEST = 'ADMIN_UPDATE_TAG_REQUEST';
export const ADMIN_UPDATE_TAG_SUCCESS = 'ADMIN_UPDATE_TAG_SUCCESS';
export const ADMIN_UPDATE_TAG_ERROR = 'ADMIN_UPDATE_TAG_ERROR';

export const ADMIN_DELETE_TAG_REQUEST = 'ADMIN_DELETE_TAG_REQUEST';
export const ADMIN_DELETE_TAG_SUCCESS = 'ADMIN_DELETE_TAG_SUCCESS';
export const ADMIN_DELETE_TAG_ERROR = 'ADMIN_DELETE_TAG_ERROR';
